<template>
  <v-card>
    <v-stepper v-model="step">
      <v-stepper-header>
        <v-stepper-step :complete="step > 1" step="1">
          Find Contact
        </v-stepper-step>
        <v-stepper-step :complete="step > 2" step="2">
          Enter Details
        </v-stepper-step>
        <v-stepper-step :complete="step > 3" step="3">
          Submit
        </v-stepper-step>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content step="1">
          <v-card-text>
            <v-text-field v-model="clientEmailSearch" placeholder="Enter email address or Surname" label="Client" />
          </v-card-text>
          <v-card-actions>
            <v-btn @click="lookupClient">Search</v-btn>
          </v-card-actions>
          <div v-if="possibleContacts">
            <div v-if="possibleContacts.length === 0">
              <v-alert type="info"> No Results found for: {{ clientEmailSearch }} </v-alert>
              <v-btn color="primary" @click="selectCreateNewContact">Create New Contact</v-btn>
            </div>
            <div v-else>
              <v-simple-table>
                <thead>
                  <tr>
                    <th>Contact</th>
                    <th>Name</th>
                    <th>Surname</th>
                    <th>Email</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="contact in possibleContacts" :key="'tr-' + contact.userId">
                    <td>
                      <v-icon v-if="contact.contactId" color="green">mdi-check</v-icon>
                      <v-icon v-else color="red">mdi-cancel</v-icon>
                    </td>
                    <td>
                      {{ contact.firstName }}
                    </td>
                    <td>
                      {{ contact.lastName }}
                    </td>
                    <td>
                      {{ contact.email }}
                    </td>
                    <td>
                      <v-btn @click="selectContact(contact)">Select</v-btn>
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </div>
          </div>
        </v-stepper-content>

        <v-stepper-content step="2">
          <v-card>
            <v-card>
              <v-card-text>
                <v-select v-model="createDealForm.stageId" label="Stage" :items="orderedStages" />
                <v-text-field v-model="createDealForm.firstName" label="First Name" />
                <v-text-field v-model="createDealForm.lastName" label="Last Name" />
                <v-text-field v-model="createDealForm.email" label="Email" :disabled="!selectedContact" />
                <v-text-field v-model="createDealForm.phone" label="Phone" />
                <v-select
                  v-model="createDealForm.dealOwnerId"
                  :items="
                    dealOwners.map((element) => {
                      return { text: element.user.firstName + ' ' + element.user.lastName, value: element.id };
                    })
                  "
                  label="Deal Owner"
                />
                <v-text-field v-model="createDealForm.attributionCampaign" label="Attribution campaign" />
                <v-text-field v-model="createDealForm.attributionMedium" label="Attribution medium" />
                <v-text-field v-model="createDealForm.attributionSource" label="Attribution source" />
                <v-textarea
                  v-model="createDealForm.note"
                  label="Note"
                  placeholder="Enter a note about the deal here."
                />
              </v-card-text>
              <v-card-actions>
                <v-col class="text-right">
                  <v-btn color="primary" @click="step = 3" :disabled="!createDealFormValid">Create Deal</v-btn>
                </v-col>
              </v-card-actions>
            </v-card>
          </v-card>
        </v-stepper-content>
        <v-stepper-content step="3">
          <v-card>
            <v-card-text>
              <v-alert v-if="!selectedContact" type="info">A new contact will be created.</v-alert>
              <v-simple-table>
                <thead>
                  <tr>
                    <th>Field</th>
                    <th>Value</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Stage</td>
                    <td>{{ selectedStageName }}</td>
                  </tr>
                  <tr>
                    <td>First Name</td>
                    <td>{{ createDealForm.firstName }}</td>
                  </tr>
                  <tr>
                    <td>Last Name</td>
                    <td>{{ createDealForm.lastName }}</td>
                  </tr>
                  <tr>
                    <td>Email</td>
                    <td>{{ createDealForm.email }}</td>
                  </tr>
                  <tr>
                    <td>Phone</td>
                    <td>{{ createDealForm.phone }}</td>
                  </tr>
                  <tr>
                    <td>Attribution Campaign</td>
                    <td>{{ createDealForm.attributionCampaign }}</td>
                  </tr>
                  <tr>
                    <td>Attribution Medium</td>
                    <td>{{ createDealForm.attributionMedium }}</td>
                  </tr>
                  <tr>
                    <td>Attribution Source</td>
                    <td>{{ createDealForm.attributionSource }}</td>
                  </tr>
                  <tr>
                    <td>Note</td>
                    <td>{{ createDealForm.note }}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-card-text>
            <v-card-actions>
              <v-btn type="primary" @click="createDeal">Create Deal</v-btn>
            </v-card-actions>
          </v-card>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </v-card>
</template>

<script>
import { DEAL_CONTACT_SEARCH_QUERY } from "@/graphql/queries/deal";
import { UPDATE_DEAL_MUTATION } from "@/graphql/mutations/deal";

export default {
  name: "DealCreateNew",
  props: {
    dealOwners: {
      type: Array,
      required: true,
    },
    stages: {
      type: Array,
      required: true,
    },
    types: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      step: 1,
      clientEmailSearch: "",
      possibleContacts: null,
      selectedContact: null,
      createDealForm: {
        stageId: null,
        dealOwnerId: null,
        firstName: "",
        lastName: "",
        phone: "",
        email: "",
        note: "",
        attributionCampaign: "",
        attributionMedium: "",
        attributionSource: "",
      },
    };
  },
  watch: {
    clientEmailSearch() {
      this.possibleContacts = null;
    },
  },
  computed: {
    createDealFormValid() {
      return (
        this.createDealForm.dealOwnerId != null &&
        this.createDealForm.firstName !== "" &&
        this.createDealForm.lastName !== "" &&
        this.createDealForm.phone !== "" &&
        this.createDealForm.stageId
      );
    },
    orderedStages() {
      let stages = JSON.parse(JSON.stringify(this.stages));
      stages.sort((a, b) => (a.order > b.order ? 1 : -1));
      return stages.map((element) => {
        return {
          value: element.id,
          text: element.title,
        };
      });
    },
    selectedStageName() {
      if (!this.createDealForm.stageId) return "";
      return this.stages.find((element) => element.id == this.createDealForm.stageId)?.title;
    },
  },
  methods: {
    init() {
      this.step = 1;
      this.possibleContacts = null;
      this.selectedContact = null;
      this.createDealForm = {
        dealOwnerId: null,
        firstName: "",
        lastName: "",
        phone: "",
        email: "",
        note: "",
        attributionCampaign: "",
        attributionMedium: "",
        attributionSource: "",
      };
    },
    async lookupClient() {
      const result = await this.$apollo.query({
        query: DEAL_CONTACT_SEARCH_QUERY,
        variables: {
          search: this.clientEmailSearch,
        },
        fetchPolicy: "no-cache",
      });
      let contact_options = result.data.dealContactSearch.contacts.map((element) => {
        return {
          contactId: element.id,
          userId: element?.user?.id,
          firstName: element.firstName,
          lastName: element.lastName,
          email: element.email,
          phone: element.phone,
        };
      });
      let user_options = result.data.dealContactSearch.users.map((element) => {
        return {
          contactId: null,
          userId: element.id,
          firstName: element.firstName,
          lastName: element.lastName,
          email: element.email,
          phone: element?.userProfile?.phone,
        };
      });
      this.possibleContacts = [...contact_options, ...user_options];
    },
    selectContact(contact) {
      this.selectedContact = contact;
      this.createDealForm.firstName = contact.firstName;
      this.createDealForm.lastName = contact.lastName;
      this.createDealForm.email = contact.email;
      this.createDealForm.phone = contact.phone;
      this.step += 1;
    },
    selectCreateNewContact() {
      this.createDealForm.email = this.clientEmailSearch;
      this.step = 2;
    },
    async commitDealTransaction(data) {
      let result = await this.$apollo.mutate({
        mutation: UPDATE_DEAL_MUTATION,
        variables: {
          data: data,
        },
      });
      return result;
    },
    async createDeal() {
      let data = JSON.parse(JSON.stringify(this.createDealForm));
      if (this.selectedContact) {
        data["contactId"] = this.selectedContact.contactId;
        data["userId"] = this.selectedContact.userId;
      }

      let manualType = this.types.find((element) => element.code === "MANUAL");
      if (manualType) data["dealTypeId"] = manualType.id;

      let result = await this.commitDealTransaction(data);
      if (result.data.upsertDealMutation.success) this.$emit("result", "Deal Created");
      else alert(result.data.upsertDealMutation.error);
    },
  },
};
</script>
